<mb-expandable-panel #contentTaxes>
    <div class="container-taxes" *ngIf="breakdown !== undefined">
      <div class="header-taxes">
        <button class="hidden-expan" (click)="hiddenPane()">
          <mb-icon-text>
            <span>Ver menos <mb-icon icon="arrow-up"></mb-icon></span>
          </mb-icon-text>
        </button>
      </div>
      <div class="taxe bold" *ngIf="rate">
        <p class="name-taxe">
          <strong *ngIf="fop === 'PAY_AT_DESTINATION'"> Valor en dólares</strong>
          <strong *ngIf="fop !== 'PAY_AT_DESTINATION'">{{ rate.key }}</strong>
        </p>
        <p class="value-taxe">
          <strong
            >{{ currencySymbol }}
            {{ rate.value | Currency }}</strong
          >
        </p>
      </div>
      <ul>
        <li *ngIf="fop === 'PAY_AT_DESTINATION'">
          <div class="taxe">
            <p class="name-taxe">El precio en pesos argentinos es estimativo</p>
          </div>
        </li>
        <li *ngFor="let charge of charges">
          <div class="taxe">
            <p class="name-taxe">{{ charge.key }}</p>
            <p class="value-taxe">{{ currencySymbol }} {{ charge.value | Currency }}</p>
          </div>
        </li>
      </ul>
     <div class="disclaimer" *ngIf="information">
        <mb-icon icon="exclamation-circle" class="icon-focus"></mb-icon>
        <p class="disclaimer__text not-pad"><strong *ngIf="information?.title">{{ information?.title }}.</strong> {{ information?.information[0] }}</p>
      </div>
    </div>
  </mb-expandable-panel>